import type { SessionAppRequirement} from './SessionManager';
import type { OpenSessionOptions } from '@easterngraphics/wcf/modules/eaiws';

import { SessionManager } from './SessionManager';

import { EAIWS_SERVER } from '@egr/xbox/utils/Constants';
import { getEnvVar } from '@egr/xbox/utils/ReactScriptHelper';

import { isNotNullOrEmpty, isNullOrEmpty } from '@easterngraphics/wcf/modules/utils/string';

const EAIWS_STARTUP: string = getEnvVar('EAIWS_STARTUP', '');
const EaiwsKeepaliveInterval: number = parseInt(getEnvVar('EAIWS_KEEPALIVE_INTERVAL', '60'), 10);
const SessionRetry: number = parseInt(getEnvVar('EAIWS_SESSION_OPEN_RETRY', '0'), 0);

/** only checks env-vars EAIWS_SERVER and EAIWS_STARTUP (default values of StaticEaiwsManager) */
export function hasArgumentsRequiredForDirectEaiwsAccess(): boolean {
    return isNotNullOrEmpty(EAIWS_SERVER) && isNotNullOrEmpty(EAIWS_STARTUP);
}

export class StaticEaiwsManager<App extends SessionAppRequirement = SessionAppRequirement> extends SessionManager<App> {
    public constructor(
        app: App,
        protected packageGroups?: Array<string>,
        private server = EAIWS_SERVER,
        private startup = EAIWS_STARTUP,
    ) {
        super(app);

        if (
            isNullOrEmpty(server) ||
            isNullOrEmpty(startup)
        ) {
            throw new Error('Incorrect eaiws setup');
        }
    }

    // Note: can be used if a second session is required
    public getSessionOpenOptions(): [string, OpenSessionOptions] {
        return [
            this.server,
            {
                startup: this.startup,
                packageGroups: this.packageGroups != null ? this.packageGroups.join(',') : undefined,
                keepAliveInterval: EaiwsKeepaliveInterval * 1000,
            },
        ];
    }

    protected async startEaiwsSession(): Promise<void> {
        // FixMe: handle return value
        let sessionOpened = false;
        let retryCount = 0;
        try {
            await this.app.eaiwsBaskets.session.open(...this.getSessionOpenOptions());
        } catch (error) {
            if (retryCount === SessionRetry) {
                throw error;
            }
            while (!sessionOpened && retryCount < SessionRetry) {
                try {
                    sessionOpened = await this.app.eaiwsBaskets.session.open(...this.getSessionOpenOptions());
                } catch {
                    //
                } finally {
                    await new Promise(resolve => window.setTimeout(resolve, 500));
                    retryCount++;
                }
            }
        }
    }
}